/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getSourceIp = /* GraphQL */ `query GetSourceIp {
  getSourceIp {
    sourceIp
    xForwardedFor
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSourceIpQueryVariables,
  APITypes.GetSourceIpQuery
>;
export const getEvent = /* GraphQL */ `query GetEvent($loginName: String!, $tenant: String!, $landscape: String!) {
  getEvent(loginName: $loginName, tenant: $tenant, landscape: $landscape) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEventQueryVariables, APITypes.GetEventQuery>;
export const listEvents = /* GraphQL */ `query ListEvents(
  $loginName: String
  $tenantLandscape: ModelEventPrimaryCompositeKeyConditionInput
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEvents(
    loginName: $loginName
    tenantLandscape: $tenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventsQueryVariables,
  APITypes.ListEventsQuery
>;
export const getLink = /* GraphQL */ `query GetLink($id: ID!) {
  getLink(id: $id) {
    id
    menuDescriptions {
      nextToken
      __typename
    }
    url
    tenant
    landscape
    sort
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLinkQueryVariables, APITypes.GetLinkQuery>;
export const listLinks = /* GraphQL */ `query ListLinks(
  $filter: ModelLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  listLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      url
      tenant
      landscape
      sort
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListLinksQueryVariables, APITypes.ListLinksQuery>;
export const getMenu = /* GraphQL */ `query GetMenu(
  $menuId: String!
  $loginName: String!
  $tenant: String!
  $landscape: String!
) {
  getMenu(
    menuId: $menuId
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
  ) {
    menuId
    parentMenuId
    menuNames {
      nextToken
      __typename
    }
    menuDescriptions {
      nextToken
      __typename
    }
    url
    isCategory
    product
    schemaId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    accessedTimeStamp
    sort
    canUseFromExtra
    menuIconFont
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMenuQueryVariables, APITypes.GetMenuQuery>;
export const listMenus = /* GraphQL */ `query ListMenus(
  $menuId: String
  $loginNameTenantLandscape: ModelMenuPrimaryCompositeKeyConditionInput
  $filter: ModelMenuFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMenus(
    menuId: $menuId
    loginNameTenantLandscape: $loginNameTenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      menuId
      parentMenuId
      url
      isCategory
      product
      schemaId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      accessedTimeStamp
      sort
      canUseFromExtra
      menuIconFont
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListMenusQueryVariables, APITypes.ListMenusQuery>;
export const getMenuDescription = /* GraphQL */ `query GetMenuDescription(
  $menuId: String!
  $language: Language!
  $tenant: String!
  $landscape: String!
  $schemaId: String!
) {
  getMenuDescription(
    menuId: $menuId
    language: $language
    tenant: $tenant
    landscape: $landscape
    schemaId: $schemaId
  ) {
    language
    description
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMenuDescriptionQueryVariables,
  APITypes.GetMenuDescriptionQuery
>;
export const listMenuDescriptions = /* GraphQL */ `query ListMenuDescriptions(
  $menuId: String
  $languageTenantLandscapeSchemaId: ModelMenuDescriptionPrimaryCompositeKeyConditionInput
  $filter: ModelMenuDescriptionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMenuDescriptions(
    menuId: $menuId
    languageTenantLandscapeSchemaId: $languageTenantLandscapeSchemaId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      language
      description
      menuId
      schemaId
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMenuDescriptionsQueryVariables,
  APITypes.ListMenuDescriptionsQuery
>;
export const getLinkMenuDescription = /* GraphQL */ `query GetLinkMenuDescription(
  $menuId: ID!
  $tenant: String!
  $landscape: String!
  $language: Language!
) {
  getLinkMenuDescription(
    menuId: $menuId
    tenant: $tenant
    landscape: $landscape
    language: $language
  ) {
    language
    description
    menuId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLinkMenuDescriptionQueryVariables,
  APITypes.GetLinkMenuDescriptionQuery
>;
export const listLinkMenuDescriptions = /* GraphQL */ `query ListLinkMenuDescriptions(
  $menuId: ID
  $tenantLandscapeLanguage: ModelLinkMenuDescriptionPrimaryCompositeKeyConditionInput
  $filter: ModelLinkMenuDescriptionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLinkMenuDescriptions(
    menuId: $menuId
    tenantLandscapeLanguage: $tenantLandscapeLanguage
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      language
      description
      menuId
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLinkMenuDescriptionsQueryVariables,
  APITypes.ListLinkMenuDescriptionsQuery
>;
export const getMenuName = /* GraphQL */ `query GetMenuName(
  $menuId: String!
  $language: Language!
  $tenant: String!
  $landscape: String!
  $schemaId: String!
) {
  getMenuName(
    menuId: $menuId
    language: $language
    tenant: $tenant
    landscape: $landscape
    schemaId: $schemaId
  ) {
    language
    name
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMenuNameQueryVariables,
  APITypes.GetMenuNameQuery
>;
export const listMenuNames = /* GraphQL */ `query ListMenuNames(
  $menuId: String
  $languageTenantLandscapeSchemaId: ModelMenuNamePrimaryCompositeKeyConditionInput
  $filter: ModelMenuNameFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMenuNames(
    menuId: $menuId
    languageTenantLandscapeSchemaId: $languageTenantLandscapeSchemaId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      language
      name
      menuId
      schemaId
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMenuNamesQueryVariables,
  APITypes.ListMenuNamesQuery
>;
export const getProductMenuName = /* GraphQL */ `query GetProductMenuName(
  $menuId: String!
  $loginName: String!
  $tenant: String!
  $landscape: String!
  $language: Language!
) {
  getProductMenuName(
    menuId: $menuId
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
    language: $language
  ) {
    language
    name
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductMenuNameQueryVariables,
  APITypes.GetProductMenuNameQuery
>;
export const listProductMenuNames = /* GraphQL */ `query ListProductMenuNames(
  $menuId: String
  $loginNameTenantLandscapeLanguage: ModelProductMenuNamePrimaryCompositeKeyConditionInput
  $filter: ModelProductMenuNameFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProductMenuNames(
    menuId: $menuId
    loginNameTenantLandscapeLanguage: $loginNameTenantLandscapeLanguage
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      language
      name
      menuId
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductMenuNamesQueryVariables,
  APITypes.ListProductMenuNamesQuery
>;
export const getNotice = /* GraphQL */ `query GetNotice($loginName: String!, $tenant: String!, $landscape: String!) {
  getNotice(loginName: $loginName, tenant: $tenant, landscape: $landscape) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNoticeQueryVariables, APITypes.GetNoticeQuery>;
export const listNotices = /* GraphQL */ `query ListNotices(
  $loginName: String
  $tenantLandscape: ModelNoticePrimaryCompositeKeyConditionInput
  $filter: ModelNoticeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNotices(
    loginName: $loginName
    tenantLandscape: $tenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNoticesQueryVariables,
  APITypes.ListNoticesQuery
>;
export const getFlag = /* GraphQL */ `query GetFlag(
  $loginName: String!
  $tenant: String!
  $landscape: String!
  $flag: Target!
) {
  getFlag(
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
    flag: $flag
  ) {
    flag
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFlagQueryVariables, APITypes.GetFlagQuery>;
export const listFlags = /* GraphQL */ `query ListFlags(
  $loginName: String
  $tenantLandscapeFlag: ModelFlagPrimaryCompositeKeyConditionInput
  $filter: ModelFlagFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlags(
    loginName: $loginName
    tenantLandscapeFlag: $tenantLandscapeFlag
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      flag
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListFlagsQueryVariables, APITypes.ListFlagsQuery>;
export const getUser = /* GraphQL */ `query GetUser($loginName: String!, $tenant: String!, $landscape: String!) {
  getUser(loginName: $loginName, tenant: $tenant, landscape: $landscape) {
    loginName
    tenant
    landscape
    displaysFavoritePanel
    isAdmin
    language
    name
    affiliation
    csrSchema
    cwsSchema
    cjkSchema
    ctmSchema
    event {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    notice {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    menus {
      nextToken
      __typename
    }
    productMenus {
      nextToken
      __typename
    }
    flags {
      nextToken
      __typename
    }
    favorites {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    announcements {
      nextToken
      __typename
    }
    scheduledEventMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledEventMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    scheduledEventHistoriesByExecutedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    productMenuNames {
      nextToken
      __typename
    }
    countTables {
      nextToken
      __typename
    }
    roleId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $loginName: String
  $tenantLandscape: ModelUserPrimaryCompositeKeyConditionInput
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUsers(
    loginName: $loginName
    tenantLandscape: $tenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      loginName
      tenant
      landscape
      displaysFavoritePanel
      isAdmin
      language
      name
      affiliation
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
      roleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getNotification = /* GraphQL */ `query GetNotification(
  $notificationId: String!
  $loginName: String!
  $tenant: String!
  $landscape: String!
) {
  getNotification(
    notificationId: $notificationId
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
  ) {
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    product
    notificationId
    content
    iconType
    onClickAction
    extraActions {
      actionName
      onClickAction
      __typename
    }
    displayStartDate
    displayEndDate
    isRead
    isFinished
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $notificationId: String
  $loginNameTenantLandscape: ModelNotificationPrimaryCompositeKeyConditionInput
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNotifications(
    notificationId: $notificationId
    loginNameTenantLandscape: $loginNameTenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      product
      notificationId
      content
      iconType
      onClickAction
      displayStartDate
      displayEndDate
      isRead
      isFinished
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const getCountTable = /* GraphQL */ `query GetCountTable(
  $loginName: String!
  $tenant: String!
  $landscape: String!
  $tableName: TableName!
) {
  getCountTable(
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
    tableName: $tableName
  ) {
    loginName
    tenant
    landscape
    tableName
    totalCount
    isUnRead
    isExpired
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCountTableQueryVariables,
  APITypes.GetCountTableQuery
>;
export const listCountTables = /* GraphQL */ `query ListCountTables(
  $loginName: String
  $tenantLandscapeTableName: ModelCountTablePrimaryCompositeKeyConditionInput
  $filter: ModelCountTableFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCountTables(
    loginName: $loginName
    tenantLandscapeTableName: $tenantLandscapeTableName
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      loginName
      tenant
      landscape
      tableName
      totalCount
      isUnRead
      isExpired
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCountTablesQueryVariables,
  APITypes.ListCountTablesQuery
>;
export const getAnnouncement = /* GraphQL */ `query GetAnnouncement($id: ID!) {
  getAnnouncement(id: $id) {
    id
    tenant
    landscape
    tenantLandscape
    users {
      nextToken
      __typename
    }
    title
    content
    linkToProductMenu
    isPublic
    displayStartDate
    displayEndDate
    priorityTag
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAnnouncementQueryVariables,
  APITypes.GetAnnouncementQuery
>;
export const listAnnouncements = /* GraphQL */ `query ListAnnouncements(
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnnouncementsQueryVariables,
  APITypes.ListAnnouncementsQuery
>;
export const getUserAnnouncement = /* GraphQL */ `query GetUserAnnouncement(
  $loginName: String!
  $tenant: String!
  $landscape: String!
  $announcementId: ID!
) {
  getUserAnnouncement(
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
    announcementId: $announcementId
  ) {
    announcementId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    announcement {
      id
      tenant
      landscape
      tenantLandscape
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
      __typename
    }
    displayStartDate
    displayEndDate
    isProcessed
    isRead
    isShow
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserAnnouncementQueryVariables,
  APITypes.GetUserAnnouncementQuery
>;
export const listUserAnnouncements = /* GraphQL */ `query ListUserAnnouncements(
  $loginName: String
  $tenantLandscapeAnnouncementId: ModelUserAnnouncementPrimaryCompositeKeyConditionInput
  $filter: ModelUserAnnouncementFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserAnnouncements(
    loginName: $loginName
    tenantLandscapeAnnouncementId: $tenantLandscapeAnnouncementId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      announcementId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      displayStartDate
      displayEndDate
      isProcessed
      isRead
      isShow
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserAnnouncementsQueryVariables,
  APITypes.ListUserAnnouncementsQuery
>;
export const getFavorite = /* GraphQL */ `query GetFavorite(
  $menuId: String!
  $loginName: String!
  $tenant: String!
  $landscape: String!
) {
  getFavorite(
    menuId: $menuId
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
  ) {
    sort
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFavoriteQueryVariables,
  APITypes.GetFavoriteQuery
>;
export const listFavorites = /* GraphQL */ `query ListFavorites(
  $menuId: String
  $loginNameTenantLandscape: ModelFavoritePrimaryCompositeKeyConditionInput
  $filter: ModelFavoriteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFavorites(
    menuId: $menuId
    loginNameTenantLandscape: $loginNameTenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      sort
      menuId
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFavoritesQueryVariables,
  APITypes.ListFavoritesQuery
>;
export const getMenuIndex = /* GraphQL */ `query GetMenuIndex(
  $index: String!
  $product: Product!
  $schema: String!
  $menuId: String!
  $language: Language!
  $tenant: String!
  $landscape: String!
) {
  getMenuIndex(
    index: $index
    product: $product
    schema: $schema
    menuId: $menuId
    language: $language
    tenant: $tenant
    landscape: $landscape
  ) {
    index
    menuId
    product
    schema
    language
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMenuIndexQueryVariables,
  APITypes.GetMenuIndexQuery
>;
export const listMenuIndexs = /* GraphQL */ `query ListMenuIndexs(
  $index: String
  $productSchemaMenuIdLanguageTenantLandscape: ModelMenuIndexPrimaryCompositeKeyConditionInput
  $filter: ModelMenuIndexFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMenuIndexs(
    index: $index
    productSchemaMenuIdLanguageTenantLandscape: $productSchemaMenuIdLanguageTenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      index
      menuId
      product
      schema
      language
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMenuIndexsQueryVariables,
  APITypes.ListMenuIndexsQuery
>;
export const getProductMenu = /* GraphQL */ `query GetProductMenu(
  $menuId: String!
  $loginName: String!
  $tenant: String!
  $landscape: String!
) {
  getProductMenu(
    menuId: $menuId
    loginName: $loginName
    tenant: $tenant
    landscape: $landscape
  ) {
    loginName
    tenant
    landscape
    menuId
    menuNames {
      nextToken
      __typename
    }
    isHome
    stateKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductMenuQueryVariables,
  APITypes.GetProductMenuQuery
>;
export const listProductMenus = /* GraphQL */ `query ListProductMenus(
  $menuId: String
  $loginNameTenantLandscape: ModelProductMenuPrimaryCompositeKeyConditionInput
  $filter: ModelProductMenuFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProductMenus(
    menuId: $menuId
    loginNameTenantLandscape: $loginNameTenantLandscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      loginName
      tenant
      landscape
      menuId
      isHome
      stateKey
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductMenusQueryVariables,
  APITypes.ListProductMenusQuery
>;
export const getGatewayServer = /* GraphQL */ `query GetGatewayServer(
  $tenant: String!
  $landscape: String!
  $product: Product!
) {
  getGatewayServer(tenant: $tenant, landscape: $landscape, product: $product) {
    tenant
    landscape
    product
    useInternetAccess
    isInternalGateWayServer
    gatewayServerIps
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGatewayServerQueryVariables,
  APITypes.GetGatewayServerQuery
>;
export const listGatewayServers = /* GraphQL */ `query ListGatewayServers(
  $tenant: String
  $landscapeProduct: ModelGatewayServerPrimaryCompositeKeyConditionInput
  $filter: ModelGatewayServerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listGatewayServers(
    tenant: $tenant
    landscapeProduct: $landscapeProduct
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      landscape
      product
      useInternetAccess
      isInternalGateWayServer
      gatewayServerIps
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGatewayServersQueryVariables,
  APITypes.ListGatewayServersQuery
>;
export const getCognitoInfo = /* GraphQL */ `query GetCognitoInfo($tenant: String!, $landscape: String!) {
  getCognitoInfo(tenant: $tenant, landscape: $landscape) {
    tenant
    landscape
    identityPoolId
    region
    userPoolId
    userPoolWebClientId
    identityProvider
    amazonCognitoDomain
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCognitoInfoQueryVariables,
  APITypes.GetCognitoInfoQuery
>;
export const listCognitoInfos = /* GraphQL */ `query ListCognitoInfos(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $filter: ModelCognitoInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCognitoInfos(
    tenant: $tenant
    landscape: $landscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      landscape
      identityPoolId
      region
      userPoolId
      userPoolWebClientId
      identityProvider
      amazonCognitoDomain
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCognitoInfosQueryVariables,
  APITypes.ListCognitoInfosQuery
>;
export const getAPIGatewayInfo = /* GraphQL */ `query GetAPIGatewayInfo($tenant: String!, $landscape: String!) {
  getAPIGatewayInfo(tenant: $tenant, landscape: $landscape) {
    tenant
    landscape
    endpoint
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAPIGatewayInfoQueryVariables,
  APITypes.GetAPIGatewayInfoQuery
>;
export const listAPIGatewayInfos = /* GraphQL */ `query ListAPIGatewayInfos(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $filter: ModelAPIGatewayInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAPIGatewayInfos(
    tenant: $tenant
    landscape: $landscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      landscape
      endpoint
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAPIGatewayInfosQueryVariables,
  APITypes.ListAPIGatewayInfosQuery
>;
export const getBackendInfo = /* GraphQL */ `query GetBackendInfo($tenant: String!, $landscape: String!) {
  getBackendInfo(tenant: $tenant, landscape: $landscape) {
    tenant
    landscape
    apiGatewayInfo {
      tenant
      landscape
      endpoint
      createdAt
      updatedAt
      __typename
    }
    cognitoInfo {
      tenant
      landscape
      identityPoolId
      region
      userPoolId
      userPoolWebClientId
      identityProvider
      amazonCognitoDomain
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBackendInfoQueryVariables,
  APITypes.GetBackendInfoQuery
>;
export const listBackendInfos = /* GraphQL */ `query ListBackendInfos(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $filter: ModelBackendInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBackendInfos(
    tenant: $tenant
    landscape: $landscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBackendInfosQueryVariables,
  APITypes.ListBackendInfosQuery
>;
export const getAuthQuery = /* GraphQL */ `query GetAuthQuery(
  $tenant: String!
  $landscape: String!
  $identityProvider: String!
  $product: Product!
) {
  getAuthQuery(
    tenant: $tenant
    landscape: $landscape
    identityProvider: $identityProvider
    product: $product
  ) {
    tenant
    landscape
    identityProvider
    product
    additionalQuery
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAuthQueryQueryVariables,
  APITypes.GetAuthQueryQuery
>;
export const listAuthQuerys = /* GraphQL */ `query ListAuthQuerys(
  $tenant: String
  $landscapeIdentityProviderProduct: ModelAuthQueryPrimaryCompositeKeyConditionInput
  $filter: ModelAuthQueryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAuthQuerys(
    tenant: $tenant
    landscapeIdentityProviderProduct: $landscapeIdentityProviderProduct
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      landscape
      identityProvider
      product
      additionalQuery
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAuthQuerysQueryVariables,
  APITypes.ListAuthQuerysQuery
>;
export const getSystemSettingInfo = /* GraphQL */ `query GetSystemSettingInfo($tenant: String!, $landscape: String!) {
  getSystemSettingInfo(tenant: $tenant, landscape: $landscape) {
    tenant
    landscape
    isMultilanguageEnabled
    isNotificationEnabled
    isJobSchedulerEnabled
    isPortalEnabled
    announcementSetting
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSystemSettingInfoQueryVariables,
  APITypes.GetSystemSettingInfoQuery
>;
export const listSystemSettingInfos = /* GraphQL */ `query ListSystemSettingInfos(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $filter: ModelSystemSettingInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSystemSettingInfos(
    tenant: $tenant
    landscape: $landscape
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      landscape
      isMultilanguageEnabled
      isNotificationEnabled
      isJobSchedulerEnabled
      isPortalEnabled
      announcementSetting
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSystemSettingInfosQueryVariables,
  APITypes.ListSystemSettingInfosQuery
>;
export const getCustomerCompanyVersion = /* GraphQL */ `query GetCustomerCompanyVersion($id: ID!) {
  getCustomerCompanyVersion(id: $id) {
    id
    tenant
    landscape
    tenantLandscape
    version
    product
    applyDateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerCompanyVersionQueryVariables,
  APITypes.GetCustomerCompanyVersionQuery
>;
export const listCustomerCompanyVersions = /* GraphQL */ `query ListCustomerCompanyVersions(
  $filter: ModelCustomerCompanyVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomerCompanyVersions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      version
      product
      applyDateTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomerCompanyVersionsQueryVariables,
  APITypes.ListCustomerCompanyVersionsQuery
>;
export const getTaskMetadata = /* GraphQL */ `query GetTaskMetadata($versionProductBatch: String!) {
  getTaskMetadata(versionProductBatch: $versionProductBatch) {
    version
    product
    batch
    batchName
    versionProductBatch
    args {
      required
      default
      display
      order
      option
      type
      delimiter
      isMultiple
      isOutputFile
      isInputFile
      isSecret
      sampleInput
      isResolvable
      __typename
    }
    requestBodyPropertyTemplates {
      requestBodyProperty
      template
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaskMetadataQueryVariables,
  APITypes.GetTaskMetadataQuery
>;
export const listTaskMetadatas = /* GraphQL */ `query ListTaskMetadatas(
  $versionProductBatch: String
  $filter: ModelTaskMetadataFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTaskMetadatas(
    versionProductBatch: $versionProductBatch
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      version
      product
      batch
      batchName
      versionProductBatch
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskMetadatasQueryVariables,
  APITypes.ListTaskMetadatasQuery
>;
export const getTenantUsingMoveFileTask = /* GraphQL */ `query GetTenantUsingMoveFileTask($tenant: String!) {
  getTenantUsingMoveFileTask(tenant: $tenant) {
    tenant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTenantUsingMoveFileTaskQueryVariables,
  APITypes.GetTenantUsingMoveFileTaskQuery
>;
export const listTenantUsingMoveFileTasks = /* GraphQL */ `query ListTenantUsingMoveFileTasks(
  $tenant: String
  $filter: ModelTenantUsingMoveFileTaskFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTenantUsingMoveFileTasks(
    tenant: $tenant
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenant
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTenantUsingMoveFileTasksQueryVariables,
  APITypes.ListTenantUsingMoveFileTasksQuery
>;
export const getJob = /* GraphQL */ `query GetJob($id: ID!) {
  getJob(id: $id) {
    id
    tenant
    landscape
    tenantLandscape
    jobCode
    title
    description
    jobTriggerFilePath
    tasks {
      nextToken
      __typename
    }
    hasOutputFile
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetJobQueryVariables, APITypes.GetJobQuery>;
export const listJobs = /* GraphQL */ `query ListJobs($filter: ModelJobFilterInput, $limit: Int, $nextToken: String) {
  listJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListJobsQueryVariables, APITypes.ListJobsQuery>;
export const getTask = /* GraphQL */ `query GetTask($jobIdOrder: String!) {
  getTask(jobIdOrder: $jobIdOrder) {
    version
    product
    batch
    batchName
    versionProductBatch
    jobId
    order
    jobIdOrder
    taskMetadata {
      version
      product
      batch
      batchName
      versionProductBatch
      createdAt
      updatedAt
      __typename
    }
    title
    args {
      order
      option
      value
      replaceInFileName
      __typename
    }
    includeInDownload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTaskQueryVariables, APITypes.GetTaskQuery>;
export const listTasks = /* GraphQL */ `query ListTasks(
  $jobIdOrder: String
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTasks(
    jobIdOrder: $jobIdOrder
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      title
      includeInDownload
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTasksQueryVariables, APITypes.ListTasksQuery>;
export const getScheduledEventMetadata = /* GraphQL */ `query GetScheduledEventMetadata($id: ID!) {
  getScheduledEventMetadata(id: $id) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    repeatType
    rruleSet
    holidayExecutionType
    useCustomHoliday
    customHolidayLabels
    eventTriggerType
    createdBy
    updatedBy
    editedAt
    expirationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScheduledEventMetadataQueryVariables,
  APITypes.GetScheduledEventMetadataQuery
>;
export const listScheduledEventMetadatas = /* GraphQL */ `query ListScheduledEventMetadatas(
  $filter: ModelScheduledEventMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  listScheduledEventMetadatas(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScheduledEventMetadatasQueryVariables,
  APITypes.ListScheduledEventMetadatasQuery
>;
export const getScheduledEventHistory = /* GraphQL */ `query GetScheduledEventHistory($id: ID!) {
  getScheduledEventHistory(id: $id) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    scheduledEventMetadataId
    scheduledEventMetadata {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    eventStartDateTime
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    jobExecutionStatus
    tasks {
      nextToken
      __typename
    }
    taskHistories {
      nextToken
      __typename
    }
    executedBy
    executionArn
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScheduledEventHistoryQueryVariables,
  APITypes.GetScheduledEventHistoryQuery
>;
export const listScheduledEventHistorys = /* GraphQL */ `query ListScheduledEventHistorys(
  $filter: ModelScheduledEventHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listScheduledEventHistorys(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      scheduledEventMetadataId
      eventStartDateTime
      jobId
      jobExecutionStatus
      executedBy
      executionArn
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScheduledEventHistorysQueryVariables,
  APITypes.ListScheduledEventHistorysQuery
>;
export const getTaskHistory = /* GraphQL */ `query GetTaskHistory($scheduledEventHistoryId: ID!, $jobIdOrder: String!) {
  getTaskHistory(
    scheduledEventHistoryId: $scheduledEventHistoryId
    jobIdOrder: $jobIdOrder
  ) {
    jobIdOrder
    jobId
    order
    scheduledEventHistoryId
    task {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      title
      includeInDownload
      createdAt
      updatedAt
      __typename
    }
    tenant
    landscape
    tenantLandscape
    taskStartDateTime
    taskEndDateTime
    taskExecutionStatus
    log
    outputFilePath
    includeInDownload
    taskTitle
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaskHistoryQueryVariables,
  APITypes.GetTaskHistoryQuery
>;
export const listTaskHistorys = /* GraphQL */ `query ListTaskHistorys(
  $scheduledEventHistoryId: ID
  $jobIdOrder: ModelStringKeyConditionInput
  $filter: ModelTaskHistoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTaskHistorys(
    scheduledEventHistoryId: $scheduledEventHistoryId
    jobIdOrder: $jobIdOrder
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      jobIdOrder
      jobId
      order
      scheduledEventHistoryId
      tenant
      landscape
      tenantLandscape
      taskStartDateTime
      taskEndDateTime
      taskExecutionStatus
      log
      outputFilePath
      includeInDownload
      taskTitle
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskHistorysQueryVariables,
  APITypes.ListTaskHistorysQuery
>;
export const getScheduledHolidayMetadata = /* GraphQL */ `query GetScheduledHolidayMetadata($id: ID!) {
  getScheduledHolidayMetadata(id: $id) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    repeatType
    rruleSet
    labels
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScheduledHolidayMetadataQueryVariables,
  APITypes.GetScheduledHolidayMetadataQuery
>;
export const listScheduledHolidayMetadatas = /* GraphQL */ `query ListScheduledHolidayMetadatas(
  $filter: ModelScheduledHolidayMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  listScheduledHolidayMetadatas(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      repeatType
      rruleSet
      labels
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScheduledHolidayMetadatasQueryVariables,
  APITypes.ListScheduledHolidayMetadatasQuery
>;
export const getPublicHoliday = /* GraphQL */ `query GetPublicHoliday($startDate: AWSDate!, $language: Language!) {
  getPublicHoliday(startDate: $startDate, language: $language) {
    startDate
    language
    title
    label
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPublicHolidayQueryVariables,
  APITypes.GetPublicHolidayQuery
>;
export const listPublicHolidays = /* GraphQL */ `query ListPublicHolidays(
  $startDate: AWSDate
  $language: ModelStringKeyConditionInput
  $filter: ModelPublicHolidayFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPublicHolidays(
    startDate: $startDate
    language: $language
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      startDate
      language
      title
      label
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPublicHolidaysQueryVariables,
  APITypes.ListPublicHolidaysQuery
>;
export const getWebsocketConnection = /* GraphQL */ `query GetWebsocketConnection($connectionId: String!) {
  getWebsocketConnection(connectionId: $connectionId) {
    connectionId
    endpoint
    tenant
    landscape
    hostname
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWebsocketConnectionQueryVariables,
  APITypes.GetWebsocketConnectionQuery
>;
export const listWebsocketConnections = /* GraphQL */ `query ListWebsocketConnections(
  $connectionId: String
  $filter: ModelWebsocketConnectionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWebsocketConnections(
    connectionId: $connectionId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      connectionId
      endpoint
      tenant
      landscape
      hostname
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWebsocketConnectionsQueryVariables,
  APITypes.ListWebsocketConnectionsQuery
>;
export const getWebsocketWaitingResponse = /* GraphQL */ `query GetWebsocketWaitingResponse($parentId: String!) {
  getWebsocketWaitingResponse(parentId: $parentId) {
    parentId
    connectionId
    messageType
    receivedAt
    timeoutAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWebsocketWaitingResponseQueryVariables,
  APITypes.GetWebsocketWaitingResponseQuery
>;
export const listWebsocketWaitingResponses = /* GraphQL */ `query ListWebsocketWaitingResponses(
  $parentId: String
  $filter: ModelWebsocketWaitingResponseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWebsocketWaitingResponses(
    parentId: $parentId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      parentId
      connectionId
      messageType
      receivedAt
      timeoutAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWebsocketWaitingResponsesQueryVariables,
  APITypes.ListWebsocketWaitingResponsesQuery
>;
export const getRole = /* GraphQL */ `query GetRole($id: ID!) {
  getRole(id: $id) {
    id
    name
    description
    isDefault
    systemType
    tenant
    landscape
    permissions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRoleQueryVariables, APITypes.GetRoleQuery>;
export const listRoles = /* GraphQL */ `query ListRoles(
  $id: ID
  $filter: ModelRoleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRoles(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      description
      isDefault
      systemType
      tenant
      landscape
      permissions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListRolesQueryVariables, APITypes.ListRolesQuery>;
export const linkByTenantLandscape = /* GraphQL */ `query LinkByTenantLandscape(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  linkByTenantLandscape(
    tenant: $tenant
    landscape: $landscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      url
      tenant
      landscape
      sort
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkByTenantLandscapeQueryVariables,
  APITypes.LinkByTenantLandscapeQuery
>;
export const menuByAccessedTimeStamp = /* GraphQL */ `query MenuByAccessedTimeStamp(
  $tenantLandscapeLoginName: String
  $accessedTimeStamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMenuFilterInput
  $limit: Int
  $nextToken: String
) {
  menuByAccessedTimeStamp(
    tenantLandscapeLoginName: $tenantLandscapeLoginName
    accessedTimeStamp: $accessedTimeStamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      menuId
      parentMenuId
      url
      isCategory
      product
      schemaId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      accessedTimeStamp
      sort
      canUseFromExtra
      menuIconFont
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MenuByAccessedTimeStampQueryVariables,
  APITypes.MenuByAccessedTimeStampQuery
>;
export const menuByProduct = /* GraphQL */ `query MenuByProduct(
  $loginName: String
  $tenantLandscapeProduct: ModelMenuProductIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMenuFilterInput
  $limit: Int
  $nextToken: String
) {
  menuByProduct(
    loginName: $loginName
    tenantLandscapeProduct: $tenantLandscapeProduct
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      menuId
      parentMenuId
      url
      isCategory
      product
      schemaId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      accessedTimeStamp
      sort
      canUseFromExtra
      menuIconFont
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MenuByProductQueryVariables,
  APITypes.MenuByProductQuery
>;
export const userByTenantLandscape = /* GraphQL */ `query UserByTenantLandscape(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByTenantLandscape(
    tenant: $tenant
    landscape: $landscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      loginName
      tenant
      landscape
      displaysFavoritePanel
      isAdmin
      language
      name
      affiliation
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
      roleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByTenantLandscapeQueryVariables,
  APITypes.UserByTenantLandscapeQuery
>;
export const userNotification = /* GraphQL */ `query UserNotification(
  $loginName: String
  $tenantLandscape: ModelNotificationUserNotificationCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  userNotification(
    loginName: $loginName
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      product
      notificationId
      content
      iconType
      onClickAction
      displayStartDate
      displayEndDate
      isRead
      isFinished
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserNotificationQueryVariables,
  APITypes.UserNotificationQuery
>;
export const notificationSortedByDisplayStartDate = /* GraphQL */ `query NotificationSortedByDisplayStartDate(
  $tenantLandscapeLoginName: String
  $displayStartDate: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationSortedByDisplayStartDate(
    tenantLandscapeLoginName: $tenantLandscapeLoginName
    displayStartDate: $displayStartDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      product
      notificationId
      content
      iconType
      onClickAction
      displayStartDate
      displayEndDate
      isRead
      isFinished
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationSortedByDisplayStartDateQueryVariables,
  APITypes.NotificationSortedByDisplayStartDateQuery
>;
export const countTableByTenantLandscapeAndLoginName = /* GraphQL */ `query CountTableByTenantLandscapeAndLoginName(
  $tenant: String
  $landscapeLoginName: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCountTableFilterInput
  $limit: Int
  $nextToken: String
) {
  countTableByTenantLandscapeAndLoginName(
    tenant: $tenant
    landscapeLoginName: $landscapeLoginName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      loginName
      tenant
      landscape
      tableName
      totalCount
      isUnRead
      isExpired
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CountTableByTenantLandscapeAndLoginNameQueryVariables,
  APITypes.CountTableByTenantLandscapeAndLoginNameQuery
>;
export const announcementByTenantLandscape = /* GraphQL */ `query AnnouncementByTenantLandscape(
  $tenantLandscape: String
  $sortDirection: ModelSortDirection
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  announcementByTenantLandscape(
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnnouncementByTenantLandscapeQueryVariables,
  APITypes.AnnouncementByTenantLandscapeQuery
>;
export const userAnnouncements = /* GraphQL */ `query UserAnnouncements(
  $loginName: String
  $tenantLandscape: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  userAnnouncements(
    loginName: $loginName
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      announcementId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      displayStartDate
      displayEndDate
      isProcessed
      isRead
      isShow
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAnnouncementsQueryVariables,
  APITypes.UserAnnouncementsQuery
>;
export const userAnnouncementsByDisplayStartDate = /* GraphQL */ `query UserAnnouncementsByDisplayStartDate(
  $tenantLandscapeLoginName: String
  $displayStartDate: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  userAnnouncementsByDisplayStartDate(
    tenantLandscapeLoginName: $tenantLandscapeLoginName
    displayStartDate: $displayStartDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      announcementId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      displayStartDate
      displayEndDate
      isProcessed
      isRead
      isShow
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAnnouncementsByDisplayStartDateQueryVariables,
  APITypes.UserAnnouncementsByDisplayStartDateQuery
>;
export const favoriteBySort = /* GraphQL */ `query FavoriteBySort(
  $loginName: String
  $tenantLandscapeSort: ModelFavoriteSortIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFavoriteFilterInput
  $limit: Int
  $nextToken: String
) {
  favoriteBySort(
    loginName: $loginName
    tenantLandscapeSort: $tenantLandscapeSort
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sort
      menuId
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FavoriteBySortQueryVariables,
  APITypes.FavoriteBySortQuery
>;
export const userFavorites = /* GraphQL */ `query UserFavorites(
  $loginName: String
  $tenantLandscape: ModelFavoriteUserFavoritesCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFavoriteFilterInput
  $limit: Int
  $nextToken: String
) {
  userFavorites(
    loginName: $loginName
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sort
      menuId
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserFavoritesQueryVariables,
  APITypes.UserFavoritesQuery
>;
export const menuIndexByMenuId = /* GraphQL */ `query MenuIndexByMenuId(
  $menuId: String
  $productSchemaLanguageTenantLandscape: ModelMenuIndexMenuIdIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMenuIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  menuIndexByMenuId(
    menuId: $menuId
    productSchemaLanguageTenantLandscape: $productSchemaLanguageTenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      index
      menuId
      product
      schema
      language
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MenuIndexByMenuIdQueryVariables,
  APITypes.MenuIndexByMenuIdQuery
>;
export const menuIndexWithoutIndexTarget = /* GraphQL */ `query MenuIndexWithoutIndexTarget(
  $index: String
  $productSchemaLanguageTenantLandscape: ModelMenuIndexIndexIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMenuIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  menuIndexWithoutIndexTarget(
    index: $index
    productSchemaLanguageTenantLandscape: $productSchemaLanguageTenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      index
      menuId
      product
      schema
      language
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MenuIndexWithoutIndexTargetQueryVariables,
  APITypes.MenuIndexWithoutIndexTargetQuery
>;
export const cognitoInfoByUserPoolId = /* GraphQL */ `query CognitoInfoByUserPoolId(
  $userPoolId: String
  $sortDirection: ModelSortDirection
  $filter: ModelCognitoInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  cognitoInfoByUserPoolId(
    userPoolId: $userPoolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      tenant
      landscape
      identityPoolId
      region
      userPoolId
      userPoolWebClientId
      identityProvider
      amazonCognitoDomain
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CognitoInfoByUserPoolIdQueryVariables,
  APITypes.CognitoInfoByUserPoolIdQuery
>;
export const versionBytenantLandscapeAndApplyDateTime = /* GraphQL */ `query VersionBytenantLandscapeAndApplyDateTime(
  $tenantLandscape: String
  $applyDateTime: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerCompanyVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  versionBytenantLandscapeAndApplyDateTime(
    tenantLandscape: $tenantLandscape
    applyDateTime: $applyDateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      version
      product
      applyDateTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VersionBytenantLandscapeAndApplyDateTimeQueryVariables,
  APITypes.VersionBytenantLandscapeAndApplyDateTimeQuery
>;
export const taskMetadatasByVersion = /* GraphQL */ `query TaskMetadatasByVersion(
  $version: String
  $sortDirection: ModelSortDirection
  $filter: ModelTaskMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  taskMetadatasByVersion(
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      version
      product
      batch
      batchName
      versionProductBatch
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TaskMetadatasByVersionQueryVariables,
  APITypes.TaskMetadatasByVersionQuery
>;
export const jobsByTenantLandscape = /* GraphQL */ `query JobsByTenantLandscape(
  $tenantLandscape: String
  $sortDirection: ModelSortDirection
  $filter: ModelJobFilterInput
  $limit: Int
  $nextToken: String
) {
  jobsByTenantLandscape(
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobsByTenantLandscapeQueryVariables,
  APITypes.JobsByTenantLandscapeQuery
>;
export const jobsByTenantLandscapeAndId = /* GraphQL */ `query JobsByTenantLandscapeAndId(
  $tenantLandscape: String
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelJobFilterInput
  $limit: Int
  $nextToken: String
) {
  jobsByTenantLandscapeAndId(
    tenantLandscape: $tenantLandscape
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobsByTenantLandscapeAndIdQueryVariables,
  APITypes.JobsByTenantLandscapeAndIdQuery
>;
export const tasksByJobId = /* GraphQL */ `query TasksByJobId(
  $jobId: ID
  $sortDirection: ModelSortDirection
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
) {
  tasksByJobId(
    jobId: $jobId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      title
      includeInDownload
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TasksByJobIdQueryVariables,
  APITypes.TasksByJobIdQuery
>;
export const scheduledEventMetadatasByTenantLandscape = /* GraphQL */ `query ScheduledEventMetadatasByTenantLandscape(
  $tenantLandscape: String
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventMetadatasByTenantLandscape(
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventMetadatasByTenantLandscapeQueryVariables,
  APITypes.ScheduledEventMetadatasByTenantLandscapeQuery
>;
export const scheduledEventMetadataByTenantLandscapeAndId = /* GraphQL */ `query ScheduledEventMetadataByTenantLandscapeAndId(
  $tenantLandscape: String
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventMetadataByTenantLandscapeAndId(
    tenantLandscape: $tenantLandscape
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventMetadataByTenantLandscapeAndIdQueryVariables,
  APITypes.ScheduledEventMetadataByTenantLandscapeAndIdQuery
>;
export const scheduledEventMetadatasByTenantLandscapeAndEventTriggerType = /* GraphQL */ `query ScheduledEventMetadatasByTenantLandscapeAndEventTriggerType(
  $tenantLandscape: String
  $eventTriggerType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventMetadatasByTenantLandscapeAndEventTriggerType(
    tenantLandscape: $tenantLandscape
    eventTriggerType: $eventTriggerType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventMetadatasByTenantLandscapeAndEventTriggerTypeQueryVariables,
  APITypes.ScheduledEventMetadatasByTenantLandscapeAndEventTriggerTypeQuery
>;
export const scheduledEventMetadatasByCreatedByTenantAndLandscape = /* GraphQL */ `query ScheduledEventMetadatasByCreatedByTenantAndLandscape(
  $createdBy: String
  $tenantLandscape: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventMetadatasByCreatedByTenantAndLandscape(
    createdBy: $createdBy
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventMetadatasByCreatedByTenantAndLandscapeQueryVariables,
  APITypes.ScheduledEventMetadatasByCreatedByTenantAndLandscapeQuery
>;
export const scheduledEventMetadatasByUpdatedByTenantAndLandscape = /* GraphQL */ `query ScheduledEventMetadatasByUpdatedByTenantAndLandscape(
  $updatedBy: String
  $tenantLandscape: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventMetadatasByUpdatedByTenantAndLandscape(
    updatedBy: $updatedBy
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventMetadatasByUpdatedByTenantAndLandscapeQueryVariables,
  APITypes.ScheduledEventMetadatasByUpdatedByTenantAndLandscapeQuery
>;
export const scheduledEventHistoriesByTenantLandscapeAndEventStartDateTime = /* GraphQL */ `query ScheduledEventHistoriesByTenantLandscapeAndEventStartDateTime(
  $tenantLandscape: String
  $eventStartDateTime: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventHistoriesByTenantLandscapeAndEventStartDateTime(
    tenantLandscape: $tenantLandscape
    eventStartDateTime: $eventStartDateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      scheduledEventMetadataId
      eventStartDateTime
      jobId
      jobExecutionStatus
      executedBy
      executionArn
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventHistoriesByTenantLandscapeAndEventStartDateTimeQueryVariables,
  APITypes.ScheduledEventHistoriesByTenantLandscapeAndEventStartDateTimeQuery
>;
export const scheduledEventHistoriesByTenantLandscapeAndId = /* GraphQL */ `query ScheduledEventHistoriesByTenantLandscapeAndId(
  $tenantLandscape: String
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventHistoriesByTenantLandscapeAndId(
    tenantLandscape: $tenantLandscape
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      scheduledEventMetadataId
      eventStartDateTime
      jobId
      jobExecutionStatus
      executedBy
      executionArn
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventHistoriesByTenantLandscapeAndIdQueryVariables,
  APITypes.ScheduledEventHistoriesByTenantLandscapeAndIdQuery
>;
export const scheduledEventHistoriesByExecutedByTenantAndLandscape = /* GraphQL */ `query ScheduledEventHistoriesByExecutedByTenantAndLandscape(
  $executedBy: String
  $tenantLandscape: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledEventHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledEventHistoriesByExecutedByTenantAndLandscape(
    executedBy: $executedBy
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      scheduledEventMetadataId
      eventStartDateTime
      jobId
      jobExecutionStatus
      executedBy
      executionArn
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledEventHistoriesByExecutedByTenantAndLandscapeQueryVariables,
  APITypes.ScheduledEventHistoriesByExecutedByTenantAndLandscapeQuery
>;
export const scheduledHolidayMetadatasByTenantLandscape = /* GraphQL */ `query ScheduledHolidayMetadatasByTenantLandscape(
  $tenantLandscape: String
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledHolidayMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledHolidayMetadatasByTenantLandscape(
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      repeatType
      rruleSet
      labels
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledHolidayMetadatasByTenantLandscapeQueryVariables,
  APITypes.ScheduledHolidayMetadatasByTenantLandscapeQuery
>;
export const scheduledHolidayMetadataByTenantLandscapeAndId = /* GraphQL */ `query ScheduledHolidayMetadataByTenantLandscapeAndId(
  $tenantLandscape: String
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledHolidayMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledHolidayMetadataByTenantLandscapeAndId(
    tenantLandscape: $tenantLandscape
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      repeatType
      rruleSet
      labels
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledHolidayMetadataByTenantLandscapeAndIdQueryVariables,
  APITypes.ScheduledHolidayMetadataByTenantLandscapeAndIdQuery
>;
export const scheduledHolidayMetadatasByCreatedByTenantAndLandscape = /* GraphQL */ `query ScheduledHolidayMetadatasByCreatedByTenantAndLandscape(
  $createdBy: String
  $tenantLandscape: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledHolidayMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledHolidayMetadatasByCreatedByTenantAndLandscape(
    createdBy: $createdBy
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      repeatType
      rruleSet
      labels
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledHolidayMetadatasByCreatedByTenantAndLandscapeQueryVariables,
  APITypes.ScheduledHolidayMetadatasByCreatedByTenantAndLandscapeQuery
>;
export const scheduledHolidayMetadatasByUpdatedByTenantAndLandscape = /* GraphQL */ `query ScheduledHolidayMetadatasByUpdatedByTenantAndLandscape(
  $updatedBy: String
  $tenantLandscape: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScheduledHolidayMetadataFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledHolidayMetadatasByUpdatedByTenantAndLandscape(
    updatedBy: $updatedBy
    tenantLandscape: $tenantLandscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      repeatType
      rruleSet
      labels
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledHolidayMetadatasByUpdatedByTenantAndLandscapeQueryVariables,
  APITypes.ScheduledHolidayMetadatasByUpdatedByTenantAndLandscapeQuery
>;
export const publicHolidaysByLanguage = /* GraphQL */ `query PublicHolidaysByLanguage(
  $language: Language
  $sortDirection: ModelSortDirection
  $filter: ModelPublicHolidayFilterInput
  $limit: Int
  $nextToken: String
) {
  publicHolidaysByLanguage(
    language: $language
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      startDate
      language
      title
      label
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PublicHolidaysByLanguageQueryVariables,
  APITypes.PublicHolidaysByLanguageQuery
>;
export const roleByTenantLandscape = /* GraphQL */ `query RoleByTenantLandscape(
  $tenant: String
  $landscape: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRoleFilterInput
  $limit: Int
  $nextToken: String
) {
  roleByTenantLandscape(
    tenant: $tenant
    landscape: $landscape
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      isDefault
      systemType
      tenant
      landscape
      permissions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RoleByTenantLandscapeQueryVariables,
  APITypes.RoleByTenantLandscapeQuery
>;
